import React from "react";
import { Container, Grid, Typography, Box, Button } from "@mui/material";
import { motion } from "framer-motion";
import { useRef } from "react";
import Trips from "./Trips";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const AnimatedButton = motion(Button);

const HowItWorks = () => {
  const navigate = useNavigate();
  const items = [
    {
      title: "Book",
      body: "Take control over your journey than ever before by reserving the seat that's right for you.",
      image: "/images/Book.png",
    },
    {
      title: "Pay",
      body: "Pay online via M-pesa or card, stress free, security is guaranteed.",
      image: "/images/Paybookingplatform.png",
    },
    {
      title: "Go",
      body: "Get your ticket confirmation from the comfort of your device, enjoy your journey.",
      image: "/images/Mainbookingplatformphoto.jpg",
    },
  ];

  const saccoLogos = [
    {
      title: "Express",
      image: "/images/ExpressShuttle-Primary.png",
    },
    {
      title: "Moline",
      image: "/images/MolineLuxuryLogo.png",
    },
    {
      title: "Bomet Travellers",
      image: "/images/BometTravellers.png",
    },
    {
      title: "Transline",
      image: "/images/transline.jpg",
    },
    {
      title: "Cherangani",
      image: "/images/Cherangani.png",
    },
    {
			title: 'Narok Line',
			image: '/images/narokline.png',
		},
    // {
    // 	title: 'greenline',
    // 	image: '/images/greenline.png',
    // },
    // {
    // 	title: '2nk',
    // 	image: '/images/2nk.png',
    // },
    // {
    // 	title: 'classic',
    // 	image: '/images/classic.png',
    // },
    // {
    // 	title: 'marangu',
    // 	image: '/images/marangu.png',
    // },
    // {
    // 	title: 'nairo',
    // 	image: '/images/nairo.png',
    // },
  ];

  const duplicatedLogos = [
    ...saccoLogos,
    // ...saccoLogos,
    // ...saccoLogos,
    // ...saccoLogos,
    // ...saccoLogos,
    // ...saccoLogos,
    // ...saccoLogos,
    // ...saccoLogos,
    // ...saccoLogos,
  ];

  const locations = [
    {
      title: "Nairobi",
      image: "/images/locations.png",
    },
    {
      title: "Nakuru",
      image: "/images/locations.png",
    },
    {
      title: "Kitale",
      image: "/images/locations.png",
    },
    {
      title: "Nyeri",
      image: "/images/locations.png",
    },
    {
      title: "Mombasa",
      image: "/images/locations.png",
    },
    {
      title: "Eldoret",
      image: "/images/locations.png",
    },
    {
      title: "Nyahururu",
      image: "/images/locations.png",
    },
    {
      title: "Narok",
      image: "/images/locations.png",
    },
    {
      title: "Kakamega",
      image: "/images/locations.png",
    },
    {
      title: "Homabay",
      image: "/images/locations.png",
    },
    {
      title: "Machakos",
      image: "/images/locations.png",
    },
    {
      title: "Meru",
      image: "/images/locations.png",
    },
  ];

  const headerVariants = {
    initial: { opacity: 0 },
    animate: {
      opacity: 1,
      transition: {
        duration: 1.2,
      },
    },
  };

  const buttonVariants = {
    hover: {
      scale: 1.05,
      transition: { duration: 0.2 },
    },
    tap: {
      scale: 0.95,
    },
  };

  return (
    <Box
      sx={{
        width: "100%",
        bgcolor: "background.paper",
        py: 4,
      }}
    >
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "32px 0",
        }}
        maxWidth={false}
        disableGutters
      >
        <Grid container spacing={3} maxWidth="xl" sx={{ padding: "32px" }}>
          <Trips />
        </Grid>
        <Box
          sx={{
            width: "100%",
            margin: "32px 0 0 0",
            height: "200px",
            background: "rgba(255, 245, 236, 1)",
            overflow: "hidden",
            position: "relative",
            display: "flex",
            alignItems: "center",
          }}
        >
          <motion.div
            style={{
              display: "flex",
              justifyContent: "center",
              textAlign: "center",
              margin: "0 auto",
              gap: "2rem",
              padding: "0 1rem",
            }}
            // animate={{
            // 	x: [0, -100 * saccoLogos.length],
            // }}
            // transition={{
            // 	duration: 20,
            // 	ease: 'linear',
            // 	repeat: Infinity,
            // }}
          >
            {duplicatedLogos.map((logo, index) => (
              <Box
                key={`${logo.title}-${index}`}
                component="img"
                src={logo.image}
                alt={logo.title}
                sx={{
                  height: "144px",
                  objectFit: "contain",
                }}
              />
            ))}
          </motion.div>
        </Box>
        <Grid container spacing={3} maxWidth="xl" sx={{ padding: "32px" }}>
          {/* <Trips /> */}
        </Grid>
        <Grid container spacing={3} maxWidth="xl" sx={{ padding: "0 16px" }}>
          <Grid item xs={12}>
            <Box sx={{ mb: 6 }}>
              {/* <Typography
                variant="h4"
                sx={{
                  fontWeight: 700,
                  mb: 1,
                }}
              >
                How it Works
              </Typography> */}

			    <Typography
                variant="h4"
                sx={(theme) => ({
                //   fontSize: "20px",
                  fontWeight: 700,
                  marginBottom: theme.spacing(4),
                  color: "#1a1a1a",
                  position: "relative",
                  letterSpacing: "0.5px",
                  "&:after": {
                    content: '""',
                    position: "absolute",
                    bottom: "-12px",
                    left: 0,
                    width: "50px",
                    height: "4px",
                    backgroundColor: theme.palette.primary.main,
                    borderRadius: "4px",
                  },
                })}
              >
                How it Works
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: "text.secondary",
                }}
              >
                Going somewhere to celebrate this season? Whether you're going
                home or somewhere to roam, we've got the easiest booking flow.
              </Typography>
            </Box>
          </Grid>

          {items.map((item, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <motion.div
                initial="initial"
                animate="animate"
                variants={headerVariants}
                whileHover={{ scale: 1.05 }}
                style={{ height: "100%" }}
              >
                <Box
                  sx={{
                    position: "relative",
                    height: 384,
                    borderRadius: "6px",
                    overflow: "hidden",
                    // boxShadow: 3,
                    backgroundImage: `url(${item.image})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    "&:hover": {
                    //   boxShadow: 6,
                    },
                  }}
                >
                  <Box
                    sx={{
                      position: "absolute",
                      bottom: 0,
                      left: 0,
                      right: 0,
                      padding: 3,
                      background: "rgba(247, 146, 34, 0.7)",
                      // background:
                      // 	'linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.6) 60%, rgba(0,0,0,0) 100%)',
                    }}
                  >
                    <Typography
                      variant="h5"
                      sx={{
                        color: "common.white",
                        fontWeight: 700,
                        mb: 1,
                      }}
                    >
                      {item.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        color: "grey.200",
                      }}
                    >
                      {item.body}
                    </Typography>
                  </Box>
                </Box>
              </motion.div>
            </Grid>
          ))}
        </Grid>

        <Grid
          container
          spacing={3}
          sx={{ marginTop: "64px", padding: "0 16px" }}
          maxWidth={"xl"}
        >
          <Grid
            item
            xs={12}
            sx={{ display: "flex", justifyContent: "space-between" }}
          >
            <Box sx={{ mb: 6 }}>
              {/* <Typography
								variant="h4"
								sx={{
									fontWeight: 700,
									mb: 1,
								}}
							>
								Our travel locations
							</Typography> */}
              <Typography
                variant="h4"
                sx={(theme) => ({
                //   fontSize: "20px",
                  fontWeight: 700,
                  marginBottom: theme.spacing(4),
                  color: "#1a1a1a",
                  position: "relative",
                  letterSpacing: "0.5px",
                  "&:after": {
                    content: '""',
                    position: "absolute",
                    bottom: "-12px",
                    left: 0,
                    width: "50px",
                    height: "4px",
                    backgroundColor: theme.palette.primary.main,
                    borderRadius: "4px",
                  },
                })}
              >
                Our travel locations
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: "text.secondary",
                }}
              >
                Check out the locations we travel to.
              </Typography>
            </Box>
            <AnimatedButton
              variant="outlined"
              color="secondary"
              variants={buttonVariants}
              whileHover="hover"
              whileTap="tap"
              onClick={() => navigate("/app/locations")}
              sx={{ height: "40px" }}
            >
              See more places
			  {/* <ArrowRight style={{ marginLeft: '8px' }} /> */}
            </AnimatedButton>
          </Grid>

          {locations.map((item, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <motion.div
                initial="initial"
                animate="animate"
                variants={headerVariants}
                // whileHover={{ scale: 1.05 }}
                style={{ height: "100%" }}
              >
                <Box
                  sx={{
                    display: "flex",
                    height: "72px",
                    minWidth: "250px",
                    // border: '1px solid rgba(0,0,0,0.2)',
                    borderRadius: "6px",
                    boxShadow: 3,
                    "&:hover": {
                      boxShadow: 3,
                    },
                  }}
                >
                  <Box
                    sx={{
                      position: "relative",
                      height: 48,
                      width: 48,
                      margin: "auto 16px",
                      alignItems: "center",
                      borderRadius: "6px",
                      overflow: "hidden",
                      backgroundImage: `url(${item.image})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                  ></Box>
                  <Typography
                    variant="h5"
                    sx={{
                      color: "black",
                      fontWeight: 700,
                      mb: 1,
                      margin: "auto 0",
                    }}
                  >
                    {item.title}
                  </Typography>
                </Box>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default HowItWorks;
